import React from "react";
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  makeStyles,
  Button,
  Grid,
  Divider,
  Box,
  Paper,
} from "@material-ui/core";
import GroupIcon from "@material-ui/icons/Group";
import PersonIcon from "@material-ui/icons/Person";
import HomeIcon from "@material-ui/icons/Home";
import ComputerIcon from "@material-ui/icons/Computer";
import CheckIcon from "@material-ui/icons/Check";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  subtitle: {
    fontSize: "1.2rem",
    fontWeight: "medium",
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  card: {
    marginBottom: theme.spacing(3),
    border: "1px solid #e0e0e0",
    borderRadius: "5px",
    transition: "transform 0.2s",
    "&:hover": {
      transform: "scale(1.05)",
    },
    backgroundColor: theme.palette.type === "dark" ? "#121212" : "#fafafa",
  },
  cardHeader: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1.5px solid #8601af",
    borderRadius: "5px",
    backgroundColor: theme.palette.type === "dark" ? "#121212" : "#fafafa",
  },
  price: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#8601af",
  },
  icon: {
    fontSize: "2rem",
    color: "#8601af",
    marginBottom: theme.spacing(1),
  },
  buyButton: {
    margin: theme.spacing(2),
    color: "#ffffff",
    backgroundColor: "#8601af",
    "&:hover": {
      backgroundColor: "#8601af",
    },
  },
  description: {
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  checkIcon: {
    color: "#8601af",
  },
  featureList: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  featureIcon: {
    marginRight: theme.spacing(1),
    color: "#8601af",
  },
}));

const Pricing = () => {
  const classes = useStyles();

  const prices = [
    {
      title: "Group Tutorials",
      price: "R75",
      packages: [
        "Package 1 (4 days) - R300",
        "Package 2 (6 days) - R450",
        "Package 3 (8 days) - R800",
      ],
      description: "Engaging group sessions with interactive learning.",
      icon: <GroupIcon className={classes.icon} />,
    },
    {
      title: "One on One Tutorials",
      price: "R150",
      packages: [
        "Package 1 (4 days) - R600",
        "Package 2 (6 days) - R900",
        "Package 3 (8 days) - R1200",
      ],
      description: "Personalized sessions tailored to individual needs.",
      icon: <PersonIcon className={classes.icon} />,
    },
    {
      title: "Home Tutorials",
      price: "R250",
      packages: [
        "Package 1 (4 days) - R1000",
        "Package 2 (6 days) - R1500",
        "Package 3 (8 days) - R2000",
      ],
      description: "Convenient learning from the comfort of your home.",
      icon: <HomeIcon className={classes.icon} />,
    },
    {
      title: "Virtual Tutorials",
      price: "R200",
      packages: [
        "Package 1 (4 days) - R800",
        "Package 2 (6 days) - R1200",
        "Package 3 (8 days) - R1600",
      ],
      description: "Flexible online sessions with expert tutors.",
      icon: <ComputerIcon className={classes.icon} />,
    },
  ];

  return (
    <Paper className={classes.container} elevation={3}>
      <Typography variant="h4" className={classes.title}>
        Our Pricing Plans
      </Typography>
      <Typography variant="h6" className={classes.subtitle}>
        Choose the best plan that fits your educational needs
      </Typography>
      <Grid container spacing={3}>
        {prices.map((price, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card className={classes.card}>
              <div className={classes.cardHeader}>
                <div className={classes.icon}>{price.icon}</div>
                <Typography variant="h5">{price.title}</Typography>
                <Typography variant="body1" className={classes.price}>
                  {price.price} per session
                </Typography>
              </div>
              <CardContent>
                <Box className={classes.featureList}>
                  {price.packages.map((pkg, idx) => (
                    <div key={idx} className={classes.featureItem}>
                      <CheckIcon className={classes.featureIcon} />
                      <Typography variant="body2">{pkg}</Typography>
                    </div>
                  ))}
                </Box>
                <Divider />
                <Typography variant="body2" className={classes.description}>
                  {price.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  className={classes.buyButton}
                  fullWidth
                >
                  Buy Now
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default Pricing;
